import { useState } from "react";
import { motion } from "motion/react";
import { PhoneInput } from "react-international-phone";
import { isValidPhoneNumber } from "react-phone-number-input";
import { dotPulse } from "ldrs";
import { peopleSvg, clockSvg } from "svg";

dotPulse.register();

const WAIT_PRESETS = [10, 15, 20, 30, 45];

export default function NewWaitlistForm({ onSubmit, submitting }) {
  const [name, setName] = useState("");
  const [numGuests, setNumGuests] = useState(0);
  const [phone, setPhone] = useState("");
  const [waitingInPerson, setWaitingInPerson] = useState(false);
  const [preset, setPreset] = useState(null);
  const [customInput, setCustomInput] = useState("");

  const phoneValid = phone && isValidPhoneNumber(phone);
  const waitTime =
    preset !== null
      ? preset
      : customInput !== "" && Number(customInput) >= 0
      ? Number(customInput)
      : null;
  const valid =
    name.trim().length > 0 &&
    numGuests > 0 &&
    waitTime !== null &&
    (waitingInPerson || phoneValid);

  function handleSubmit() {
    if (!valid) return;
    onSubmit({
      name: name.trim(),
      numGuests,
      phone: waitingInPerson ? "" : phone,
      waitTime,
      waitingInPerson,
    });
  }

  function handlePresetClick(min) {
    setPreset(min);
    setCustomInput("");
  }

  function handleCustomChange(value) {
    setCustomInput(value);
    setPreset(null);
  }

  return (
    <motion.div
      className="waitlist-form"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 8 }}
      transition={{ duration: 0.18 }}
    >
      <div className="new-res-input-group">
        <label className="new-res-label">{peopleSvg()} Guest Info</label>
        <input
          type="text"
          className={`new-res-input ${!name && "new-res-unselect"}`}
          placeholder="Name"
          autoComplete="off"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <select
          className={`new-res-input ${!numGuests ? "new-res-unselect" : ""}`}
          onChange={(e) => setNumGuests(e.target.selectedIndex)}
        >
          <option default hidden value="">Party Size</option>
          <option>1 guest</option>
          {[...Array(29)].map((_, index) => (
            <option key={index + 2}>{index + 2} guests</option>
          ))}
        </select>
        <div className="waitlist-contact-toggle">
          <PhoneInput
            defaultCountry="us"
            hideDropdown
            showCountrySelector={false}
            disableDialCodePrefill
            placeholder="Phone"
            className={`new-res-input input-phone ${!phone && "new-res-unselect"}`}
            value={phone || ""}
            onChange={(value) => { setPhone(value); if (value) setWaitingInPerson(false); }}
            onFocus={() => { if (!phone) setPhone("+1"); setWaitingInPerson(false); }}
            onBlur={() => { if (phone === "+1") setPhone(""); }}
          />
          <span className="waitlist-contact-or">or</span>
          <button
            type="button"
            className={`waitlist-time-chip ${waitingInPerson ? "active" : ""}`}
            onClick={() => { setWaitingInPerson(true); setPhone(""); }}
          >
            Waiting in restaurant
          </button>
        </div>
      </div>

      <div className="new-res-input-group">
        <label className="new-res-label">{clockSvg()} Wait Time</label>
        <div className="waitlist-time-presets">
          {WAIT_PRESETS.map((min) => (
            <button
              key={min}
              type="button"
              className={`waitlist-time-chip ${preset === min ? "active" : ""}`}
              onClick={() => handlePresetClick(min)}
            >
              {min} min
            </button>
          ))}
        </div>
        <input
          type="number"
          className={`new-res-input ${!customInput && "new-res-unselect"}`}
          placeholder="Custom wait time (minutes)"
          inputMode="numeric"
          min="0"
          value={customInput}
          onChange={(e) => handleCustomChange(e.target.value)}
        />
      </div>

      <button
        type="button"
        className={`${submitting ? "loading-button" : ""} submit-button submit-new-res ${!valid ? "submit-disabled" : ""}`}
        disabled={!valid || submitting}
        onClick={handleSubmit}
      >
        {submitting ? <l-dot-pulse size="50" speed="1.6" color="white" /> : "Add to Waitlist"}
      </button>
    </motion.div>
  );
}
